import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import selectAllProps from './selectors';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import darkBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import {blueGrey500, blueGrey800, blueGrey900} from 'material-ui/styles/colors';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MyAppBar from '../../components/MyAppBar';
import MyDrawer from '../../components/MyDrawer';

class App extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const mainContainerStyle = (this.props.isLoggedIn) ? {
                minHeight: 600,
                paddingLeft: 256,
                paddingRight: 15,
                marginTop: 80,
                marginLeft: 20
            } : {minHeight: 600, paddingLeft: 0, marginTop: 80, marginLeft: 20};
        return (
            <MuiThemeProvider muiTheme={getMuiTheme({
                palette: {
                    primary1Color: blueGrey900,
                    primary2Color: blueGrey800,
                    primary3Color: blueGrey500,
                    textColor: blueGrey900
                },
                appBar: {
                    height: 50,
                },
            })}>
                <div>
                    <MyAppBar {...this.props} />
                    <MyDrawer {...this.props} />
                    <div style={mainContainerStyle}>
                        {this.props.children}
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    children: React.PropTypes.node,
    me: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    currentDate: PropTypes.string
};

function mapStateToProps(state, ownProps) {
    return selectAllProps(state);
}

function mapDispatchToProps(dispatch) {
    return {
        //actions: bindActionCreators(action, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


/** WEBPACK FOOTER **
 ** ./src/container/App/index.js
 **/